<template>
  <div class="HomeTitle">
      <div class="HomeTitle_title">{{title}}</div>
      <div class="HomeTitle_subTitle">{{subTitle}}</div>
  </div>
</template>

<script>

export default {
  name: "homeTitle",
  props:['title', 'subTitle'],
  data() {
    return {}
  },
  methods: {},
};
</script>
<style lang="scss">
.HomeTitle{
    .HomeTitle_title{
        height: 45px;
        overflow: hidden;
        font-size: 32px;
        font-family: PingFangSC;
        font-weight: 600;
        text-align: center;
        color: #19232b;
        line-height: 45px;
        margin-bottom: 10px;
    }
    .HomeTitle_subTitle{
        font-size: 16px;
        font-family: PingFangRegular;
        font-weight: 400;
        text-align: center;
        color: #616a72;
        line-height: 28px;
    }
}  
</style>
